import loadable from '@loadable/component';

export const AuthForgotPasswordPageLoadable = loadable(
  () => import('./AuthForgotPasswordPage'),
  { resolveComponent: (module) => module.AuthForgotPasswordPage },
);
